export class QnARecordForDelete {
    engagementId: number;
    workItemId: string;
    updatedBy: string;
}
